import * as yup from 'yup';

export const classifierUniqueSchema = yup.object().shape({
  nome_regra: yup.string(),
  data_vigencia: yup.string().required('Data da Vigência é obrigatória'),
  ncm: yup
    .string()
    .test(
      'ncm-format',
      'NCM deve ter exatamente 8 dígitos',
      function (value) {
        // Só valida o formato se o campo estiver preenchido
        if (!value || value.trim() === '') {
          return true;
        }
        return /^[0-9]{8}$/.test(value);
      }
    )
    .test(
      'ncm-or-ean-required',
      'NCM ou EAN/GTIN é obrigatório',
      function (value) {
        const ncm = value?.trim() || '';
        const cean = this.parent.cean?.trim() || '';
        // Pelo menos um dos campos deve estar preenchido
        return ncm.length > 0 || cean.length > 0;
      }
    ),
  cean: yup
    .string()
    .test(
      'ncm-or-ean-required',
      'NCM ou EAN/GTIN é obrigatório',
      function (value) {
        const cean = value?.trim() || '';
        const ncm = this.parent.ncm?.trim() || '';
        // Pelo menos um dos campos deve estar preenchido
        return ncm.length > 0 || cean.length > 0;
      }
    ),
  origem: yup.string().required('Origem do produto é obrigatória'),
  tipo_irpj: yup.string().required('Regime Tributário é obrigatório'),
  remetente: yup.string().required('Remetente é obrigatório'),
  uf_origem: yup.string().required('UF Origem é obrigatória'),
  identificador_operacao: yup.string().default('1'),
  nat_op: yup.string().required('Natureza da operação é obrigatória'),
  finalidade: yup.string().required('Finalidade é obrigatória'),
  destinatario: yup.string().required('Destinatário é obrigatório'),
  uf_destino: yup.string().required('UF Destino é obrigatória'),
});

